import { Entity, MicroMClient } from "@mcurros2/microm";
import { PersonalGestionFiltersDef } from "./PersonalGestionFiltersDef";


export class PersonalGestionFilters extends Entity<PersonalGestionFiltersDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new PersonalGestionFiltersDef(), parentKeys);
        this.Form = import('./PersonalGestionFiltersForm').then((module) => module.PersonalGestionFiltersForm);
        this.Title = "Personal Filters";
    }
}